import { connect, mapReadPretty, mapProps } from "@formily/react";
import { TextAreaField as TextAreaFieldBase } from "../base/TextAreaField";
import { isField } from "@formily/core";

export const TextAreaField = connect(
  TextAreaFieldBase,
  mapProps((props, field) => {
    if (!isField(field)) return props;

    return {
      ...props,
      label: field.title,
      description: field.description,
      errorMessage: field.selfErrors[0],
      isDisabled: field.disabled,
      onChange: (value) => {
        void field.onInput(value);
      },
    };
  }),
  mapReadPretty((props) => {
    return `${props.value}`;
  }),
);
